import { render, staticRenderFns } from "./SetClipartTable.vue?vue&type=template&id=935195ec&scoped=true"
import script from "./SetClipartTable.vue?vue&type=script&lang=js"
export * from "./SetClipartTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935195ec",
  null
  
)

export default component.exports